import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

//Service - Get All
export const GetAll = createAsyncThunk(
  "services/service/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Services.Service}?name=${filter?.name || ""}&category_id=${filter?.category_id || ""}
        &description=${filter?.description || ""}&image=${filter?.image || ""}
        &bestfor_id=${filter?.bestfor_id || ""}&servinclude_id=${filter?.servinclude_id || ""}
        &key_benefit_id=${filter?.key_benefit_id || ""}
        &page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Service - Get Single
export const GetSingle = createAsyncThunk(
  "services/service/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Services.Service}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Service - Create
export const Create = createAsyncThunk(
  "services/service/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Services.Service, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Service update
export const Update = createAsyncThunk(
  "services/service/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Services.Service}/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Service - Delete
export const Delete = createAsyncThunk(
  "services/service/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.Services.Service}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//Service - Status
export const StatusService = createAsyncThunk(
  "services/service/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Services.Service}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


export const StatusBestSeller = createAsyncThunk(
  "services/service/best",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Services.Service}/best/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


//Delete 1 service Image
export const DeleteServiceImage = createAsyncThunk(
  "service/deleteServiceImage",
  async (id, { rejectWithValue }) => {
    try {
      const res = await DELETE(`/admin/services/service/image/${id}`);
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const Slice = createSlice({
  name: "service",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      //GET ALL
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // GET SINGLE
      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // CREATE
      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload?.data);
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //UPDATE
      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const updated = action.payload?.data;
        const index = state.data.findIndex(
          (service) => service.id === updated?.id,
        );
        if (index !== -1) {
          state.data[index] = updated;
        }
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //DELETE
      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = state.data.filter(
          (service) => service.id !== action.payload,
        );
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // STATUS
      .addCase(StatusService.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusService.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const updated = action.payload?.data;
        const index = state.data.findIndex(
          (service) => service.id === updated?.id,
        );
        if (index !== -1) {
          state.data[index] = updated;
        }
      })
      .addCase(StatusService.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })


      // STATUS
      .addCase(StatusBestSeller.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusBestSeller.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const updated = action.payload?.data;
        const index = state.data.findIndex(
          (service) => service.id === updated?.id,
        );
        if (index !== -1) {
          state.data[index] = updated;
        }
      })
      .addCase(StatusBestSeller.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const {} = Slice.actions;

export default Slice.reducer;
